import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND_CONFIG } from '../config/brandConfig';

function Navbar({ user, onLogout }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/inventory', label: 'Inventory' },
    { path: '/cash-cars', label: 'Cash Cars' },
    { path: '/lease-cars', label: 'Lease Cars' },
    { path: '/lease-calculator', label: 'Lease Calculator' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          {BRAND_CONFIG.logo ? (
            <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.name} className="navbar-logo-image" />
          ) : (
            <div className="navbar-logo-text">{BRAND_CONFIG.name}</div>
          )}
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-nav desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'nav-link-active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right Side Actions */}
        <div className="navbar-actions desktop-nav">
          <Link to="/favorites" className="nav-action-link">
            <span className="nav-action-icon">♥</span>
            <span className="nav-action-text">Favorites</span>
          </Link>
          
          {user ? (
            <>
              <Link to={user.role === 'admin' ? '/admin' : '/dashboard'} className="nav-action-link">
                <span className="nav-action-icon">👤</span>
                <span className="nav-action-text">{user.role === 'admin' ? 'Admin' : 'Profile'}</span>
              </Link>
              <button onClick={onLogout} className="nav-logout-btn">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-login-btn">
                Login
              </Link>
              <Link to="/contact" className="nav-cta-btn">
                Get in Touch
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'mobile-nav-open' : ''}`}>
        <div className="mobile-nav-content">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${location.pathname === link.path ? 'mobile-nav-link-active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          
          <div className="mobile-nav-divider"></div>
          
          <Link to="/favorites" className="mobile-nav-link">
            Favorites
          </Link>
          
          {user ? (
            <>
              <Link to={user.role === 'admin' ? '/admin' : '/dashboard'} className="mobile-nav-link">
                {user.role === 'admin' ? 'Admin Panel' : 'Dashboard'}
              </Link>
              <button onClick={onLogout} className="mobile-nav-logout">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="mobile-nav-link">
                Login
              </Link>
              <Link to="/register" className="mobile-nav-link">
                Register
              </Link>
            </>
          )}
          
          <Link to="/contact" className="mobile-nav-cta">
            Get in Touch
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
